import React from "react";
import { Link } from "react-router-dom";

import { localizer } from '../../Translator.js'

import Container from '@material-ui/core/Container'
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import Paper from '@material-ui/core/Paper';
import { Backdrop, CircularProgress } from "@material-ui/core"
import { Button, IconButton, Tooltip} from  "@material-ui/core"
import Typography from '@material-ui/core/Typography'
import { Grid } from "@material-ui/core";
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'

import { SnackbarCustom } from "../Utilities/SnackbarCustom"
import DateCustom from '../Utilities/DateCustom'
import Roles from "../Utilities/Roles.js"


import { TableRowHeaderStyled } from '../common/TableStyled.js'
import { TableRowStyled, TableCellStyled, TableStyled } from '../common/TableStyled.js'
import ScreenHeading from "../common/ScreenHeading.js";

import AuthCli from "../../sdk/AuthCli.js";
/**
 * Class component to show list of invitations
 */
export class InvitationsLayout extends React.Component {
    
  constructor(props) {
    super(props)
    this.state = {
      // To contain all invitations ever generated in the system.
      invitations: [],
      realm: null,

      isLoading: false,
      severity: "info",
      message: null
    }
  }

  /**
 * Loading the table of existing invitations.
 */
  componentDidMount() {
    AuthCli.GetSessionInfo().then(session => {
      if (session) {
        if (session.role !== Roles.ROLE_ADMIN.Name) {
          window.location.href = "shipment"
        } else {
          this.loadInvitations()
        }
      }
    })
  }

  /**
  * Retrieves from server the list of all invitations ever generated.
  */
  loadInvitations = () => {
    this.setState({ isLoading: true })
    AuthCli.GetAllInvitationsOfRealm().then(allInvitations => {
      if (allInvitations !== null && allInvitations.toString().startsWith("[ERR")) {
        this.setState({ message: allInvitations.substring(allInvitations.indexOf(' ')), severity: "error", invitations: [] })
      } else {
        this.setState({ invitations: allInvitations ? allInvitations : [] })
      }
    })
    this.setState({ isLoading: false })
  }

  handleonClose = () => {
    this.setState({ message: null })
  }

  /**
   * open and close the modal to confirm the invitation removal
   */
  setOpenModal = (invitation) => { this.setState({ open: true, currentInvitation: invitation }) }
  doClose = () => { this.setState({ open: false, currentInvitation: null }) }

  doRevokeInvitation = () => {
    AuthCli.RevokeInvitation(this.state.currentInvitation).then(response => {
      if (response !== null && response.toString().startsWith("[ERR")) {
        this.setState({ message: response.substring(response.indexOf(' ')), severity: "error" })
      } else {
        this.loadInvitations()
        this.doClose()
      }
    })
  }

  render() {
    return (
      <React.Fragment>
        <Container className="pl-18 pr-18 pb-12 pt-55">
          {/*  <GridHeaderComponent container direction="row" spacing={4}>
            <Grid item md={9}>
              <Typography className="typography-generic header-title"><i className="fa-solid fa-handshake font-size-25 m-0-auto" /> {localizer.Invitations}</Typography>
            </Grid>
            <Grid item md={3} style={{ textAlign: "right" }}>
              <Button className="button-generic secondary-header" variant="contained" style={{top: "calc(50% - 20px)"}} color="primary" component={Link} to="/invite"
                startIcon={<i className="fa-solid fa-user-plus"></i>}>
                {localizer.UsersHeaderButton}
              </Button>
            </Grid>
          </GridHeaderComponent> */}

          {/* Screen heading. */}
          <ScreenHeading className="typography-generic"
            icon={<i className="fa-solid fa-handshake icon-button-header mr-20 ml-20"></i>}
            title={localizer.Invitations}
            button={<Button className="button-generic secondary-header" variant="contained" style={{ top: "calc(50% - 20px)" }} color="primary" component={Link} to="/invite"
              startIcon={<i className="fa-solid fa-user-plus"></i>}>
              {localizer.UsersHeaderButton}
            </Button>}
          />

          <Grid container direction="row" justify="center" alignItems="center" spacing={4} className="pt-25">
            <TableContainer component={Paper}>
              <TableStyled>
                <TableHead>
                  <TableRowHeaderStyled key={"head"}>
                    <TableCell className="typography-generic tablerow-header" align="center">{localizer.InvitedEmail}</TableCell>
                    <TableCell className="typography-generic tablerow-header" align="center">{localizer.InvitedWorkingGroup}</TableCell>
                    <TableCell className="typography-generic tablerow-header" align="center">{localizer.InvitedRole}</TableCell>
                    <TableCell className="typography-generic tablerow-header" align="center">{localizer.InvitedDate}</TableCell>
                    <TableCell className="typography-generic tablerow-header" align="center">{localizer.InvitedExpiritation}</TableCell>
                    <TableCellStyled align="center"><Typography className="typography-generic tablerow-header"></Typography></TableCellStyled>
                  </TableRowHeaderStyled>
                </TableHead>
                <TableBody>
                  {this.state.invitations.map((row) => {
                    return (
                      <TableRowStyled key={row.code}>
                        <TableCellStyled className="typography-generic tablerow-content" align="center">{row['userEmail']}</TableCellStyled>
                        <TableCellStyled className="typography-generic tablerow-content" align="center">{row['realm']}</TableCellStyled>
                        <TableCellStyled className="typography-generic tablerow-content" align="center">{row['role']}</TableCellStyled>
                        <TableCellStyled className="typography-generic tablerow-content" align="center">{DateCustom.formatDateShort(row['invitationTime'].split('T')[0])}</TableCellStyled>
                        <TableCellStyled className="typography-generic tablerow-content" align="center">{DateCustom.formatDateShort(row['invitationExpiration'].split('T')[0])}</TableCellStyled>
                        <TableCellStyled className="typography-generic tablerow-content" align="center">
                          <Tooltip title={<Typography className="typography-generic small">{localizer.DeleteInvitation}</Typography>}>
                            <IconButton key={row.code} className="button-generic icon-button" aria-label="Delete" onClick={() => this.setOpenModal(row)}>
                              <i className="fa-solid fa-trash-can"></i>
                            </IconButton>
                          </Tooltip>
                        </TableCellStyled>
                      </TableRowStyled>
                    )
                  })}
                </TableBody>
              </TableStyled>
            </TableContainer>
          </Grid>
        </Container>

        {/* Dialog to confirm invitation removal */}
        <Dialog
          open={this.state.open}
          onClose={this.doClose}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          fullWidth
          maxWidth={"sm"}
        >
          <DialogTitle id="alert-dialog-title" className="pb-0">
            <i className="fa-solid fa-circle-xmark closeoutlinedicon-custom" onClick={this.doClose}></i>
            <Typography className="typography-generic dialog-title"> {localizer.DeleteInvitation}</Typography>
          </DialogTitle>
          <DialogContent dividers={true} className="dialog-content">
            <Grid container direction="row">
              <Grid item md={12}>
                <Typography className="typography-generic">{localizer.formatString(localizer.InvitationsRevoke, this.state.currentInvitation ? <b>{this.state.currentInvitation.userEmail} </b> : "")}</Typography>
              </Grid>
            </Grid>
            <Grid item md={12} className="mt-10">
              <Button className="button-generic dialog-delete" variant="outlined" onClick={this.doRevokeInvitation}>{localizer.Delete}</Button>
              <Button className="button-generic dialog-cancel" variant="outlined" onClick={this.doClose}> {localizer.Cancel}</Button>
            </Grid>
          </DialogContent>
        </Dialog>

        {/* Upload draft error. */}
        <SnackbarCustom message={this.state.message} severity={this.state.severity} handleonClose={this.handleonClose} />
    
        {/* Waiting for service response. */}
        {this.state.isLoading &&
          <Backdrop open={this.state.isLoading} style={{ zIndex: 100 }}>
            <CircularProgress color="secondary" />
          </Backdrop>
        }
      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/invite/InvitationsLayout.js